import * as actionTypes from 'constants/actionTypes'
import createReducer from 'utils/createReducer'

export const defaultState = {
  open: false,
  message: null,
  errMessage: null
}

const errorReducer = () => {
  return createReducer(defaultState, {
    [`${actionTypes.ERROR_OPEN}`] (state, { payload }) {
      return {
        ...state,
        ...payload,
        open: true
      }
    },

    [`${actionTypes.ERROR_CLOSE}`] (state) {
      return {
        ...state,
        open: false
      }
    }
  })
}

export default errorReducer
